const RULES = [
  [/\bein\b|employer identification|cp ?575|147c/i, "ein"],
  [/insurance|liability coverage|bond/i, "insurance"],
  [/articles|certificate of formation|incorporation|organization filing|llc filing/i, "articles"],
  [/operating agreement|bylaws/i, "bylaws"],
  [/\bw-?9\b/i, "w9"],
  [/good standing/i, "good_standing"],
  [/lease|rental agreement/i, "lease"],
  [/tax return|financial statement|bank statement/i, "financials"],
];

export function vaultCategory(r) {
  const text = `${r.proof || ""} ${r.title || ""}`;
  const hit = RULES.find(([re]) => re.test(text));
  if (hit) return hit[1];
  return r.tier === "owner" ? "other" : "business_license";
}
